import { Component, OnInit } from '@angular/core';
import { GolfEventService } from '../../services/golf-event.service';
import { GolfEvent } from '../../models/GolfEvent';
import { NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { CreateEventComponent } from './create-event/create-event.component';
import { PERMISSIONS } from '../../models/constants';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-golf-event-list',
  standalone: true,
  imports: [NgFor, NgIf, CreateEventComponent],
  templateUrl: './golf-event-list.component.html',
  styleUrl: './golf-event-list.component.css'
})
export class GolfEventListComponent implements OnInit {
constructor(private golfEventService:GolfEventService, private router:Router, private authenticationService:AuthenticationService, private applicationService:ApplicationService) {}

  eventList:Array<GolfEvent> = [];
  canAddEvent:boolean = false;
  visibleComponent:string = "LIST"

  ngOnInit(): void {
    this.setupPermissions();
    this.getGolfEvents();
  }

  async setupPermissions():Promise<void> {
    this.canAddEvent = await this.authenticationService.hasPermission(PERMISSIONS.EVENTADMIN);
  }

  async getGolfEvents() {
    this.applicationService.showGlobalSpinner()
    this.eventList = await this.golfEventService.searchEvents();
    this.applicationService.hideGlobalSpinner();
  }

  switchVisibleComponent(component:string):void {
    this.visibleComponent = component;
  }

  async refreshEventList() {
    this.switchVisibleComponent('LIST');
    await this.getGolfEvents();
  }

  navigateToEvent(event:GolfEvent):void {
    if(event.type === 'LEAGUE') {
      this.router.navigate([`/league/${event.id}`]);
    }
  } 
}
